import cn from 'classnames';
import { TransferStatuses } from 'services/requests';
import { userStatus } from 'utils';
import { USER_STATUS } from 'constants/status';

import messages from './Label.messages';
import styles from './Label.module.css';

export enum EntityStatus {
  User = 'User',
  Transfer = 'Transfer',
}

enum StatusType {
  negative = 'negative',
  neutral = 'neutral',
  positive = 'positive',
  draft = 'draft',
}

export interface LabelType {
  entityStatus?: string;
  status?: string;
  isAccountClosed?: boolean;
}

interface Props {
  label: LabelType;
  className?: string;
}

const typeStatus = ({ status, entityStatus }: LabelType): StatusType => {
  if (entityStatus === EntityStatus.User) {
    switch (status) {
      case USER_STATUS.active:
        return StatusType.positive;
      case USER_STATUS.idvDeclined:
      case USER_STATUS.kycDeclined:
      case USER_STATUS.accountCreationFailed:
        return StatusType.negative;
      case USER_STATUS.invited:
      case USER_STATUS.accepted:
      case USER_STATUS.kycNotStarted:
      case USER_STATUS.kycSubmitted:
      case USER_STATUS.kycInReview:
      case USER_STATUS.kycApproved:
      case USER_STATUS.idvNotStarted:
      case USER_STATUS.idvSubmitted:
      case USER_STATUS.idvInReview:
      case USER_STATUS.idvApproved:
      case USER_STATUS.accountProcessing:
        return StatusType.neutral;
      default:
        return StatusType.draft;
    }
  }
  if (entityStatus === EntityStatus.Transfer) {
    switch (status) {
      case TransferStatuses.Processed:
        return StatusType.positive;
      case TransferStatuses.Processing:
        return StatusType.neutral;
      case TransferStatuses.NonProcessed:
        return StatusType.negative;
      default:
        return StatusType.draft;
    }
  }

  return StatusType.draft;
};

const labelStatus = (label: LabelType) => {
  switch (label.entityStatus) {
    case EntityStatus.User:
      return userStatus(label.status);
    case EntityStatus.Transfer:
      return label.status;
    case undefined:
      return label.status;
  }
};

const Label = ({ label, className }: Props): JSX.Element => (
  <div className={styles.labelsWrapper}>
    <div className={cn(styles[typeStatus(label)], className)}>{labelStatus(label)}</div>

    {label.isAccountClosed && (
      <div className={styles[StatusType.negative]}>{messages.accountClosedLabelText}</div>
    )}
  </div>
);

export default Label;
